export default __webpack_public_path__ + "static/media/HbHeaderLeft1.1c9dbdab.svg";